import React, { useState, useEffect, useCallback, useRef } from 'react';

function ClientViewDragRegion({value}) {
    const [isWindowMaximise, setIsWindowMaximise] = useState(false)
    const [maximizeIcon, setMaximiseIcon] = useState("check_box_outline_blank")

    const handleMinimize = async () => {
        if (window.pywebview && window.pywebview.api && window.pywebview.api.minimize_window) {
            await window.pywebview.api.minimize_window();
        }
    };

    const handleMaximize = async () => {
        if (window.pywebview && window.pywebview.api && window.pywebview.api.maximize_window && window.pywebview.api.resize_window) {
            await window.pywebview.api.maximize_window();
            if (!isWindowMaximise) {
                setIsWindowMaximise(true);
                setMaximiseIcon("tab_inactive")
            } else {
                setIsWindowMaximise(false);
                setMaximiseIcon("check_box_outline_blank")
            }
        }
    };

    const handleClose = async () => {
        if (window.pywebview && window.pywebview.api && window.pywebview.api.close_window) {
            await window.pywebview.api.close_window();
        }
    };

    return (
        <div className={`fixed z-[999] w-full h-8 flex items-center justify-between bg-white dark:bg-[#0c1219] border-b border-slate-300 dark:border-[#233648] select-none pywebview-drag-region`}>
            <div className="flex items-center gap-2 px-3">
                <span className="material-symbols-outlined text-[14px] text-primary">speed</span>
                <span className="text-[11px] font-medium text-slate-600 dark:text-slate-400">LiveTelemetry Client</span>
            </div>

            <div className="flex h-full">
                <button onClick={handleMinimize} className="flex items-center justify-center w-10 h-full hover:bg-slate-200 dark:hover:bg-white/10 transition-colors">
                    <span className="material-symbols-outlined  text-[16px] mt-[-10px]">minimize</span>
                </button>

                <button onClick={handleMaximize} className="flex items-center justify-center w-10 h-full hover:bg-slate-200 dark:hover:bg-white/10 transition-colors">
                    <span className="material-symbols-outlined text-[14px]">{maximizeIcon}</span>
                </button>
                <button onClick={handleClose} className="flex items-center justify-center w-10 h-full hover:bg-red-500 hover:text-white transition-colors">
                    <span className="material-symbols-outlined text-[16px]">close</span>
                </button>
            </div>
        </div>
    )
}

export default ClientViewDragRegion;